module.exports = __webpack_public_path__ + "static/media/icon_flat.605170f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Icons/icon_flat.svg
// module id = 1416
// module chunks = 0